import api from '../services/api';
import { useStartGame } from '../hooks/useStartGame';
import { useGame } from '../context/GameContext';
import { useLanguage } from '../context/LanguageContext';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import PageWrapper from '../components/wrapper/FlexiblePageWrapper';
import GhostWrapper from '../components/wrapper/GhostWrapper';
import GameEndGhosts from '../components/ghosts/GameEndGhosts';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Button from './../components/general/Button';
import Scoreboard from '../components/game/Scoreboard';
import SurveyInfo from '../components/general/SurveyInfo';
import TextInfo from '../components/text/TextInfo';
import Searchbar from '../components/general/Searchbar';
import VideoInfo from '../components/video/VideoInfo';
import Footer from './../components/general/Footer';

function GameEnd() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();

  const { gameState, handleStartGame } = useStartGame();
  const { getStatistics } = useGame();

  const statistics = getStatistics();
  const hasSubmitted = useRef(false);

  const rounds = [searchParams.get('r1'), searchParams.get('r2'), searchParams.get('r3')];
  const totalScore = searchParams.get('ts');

  useEffect(() => {
    const submitStatistics = async () => {
      if (hasSubmitted.current) {
        return;
      }

      const statisticsJson = JSON.stringify(statistics, null, 2);

      try {
        hasSubmitted.current = true;
        const response = await api.publishGameStatistics(statisticsJson);
      } catch (err) {
        console.error('Submit failed:', err);
        hasSubmitted.current = false;
        alert('Failed to submit statistics. Please try again.');
      }
    };

    if (statistics && !hasSubmitted.current) {
      submitStatistics();
    }
  }, [statistics]);

  return (
    <PageWrapper>
      <GhostWrapper>
        <Header text={t('headerTitle')} />
        <main className="w-full max-w-4xl mx-auto sm:px-4 pt-36 pb-28 flex flex-col items-center gap-6">
          <Title size="small" text={t('title')} />
          <br />
          <br />
          <Scoreboard rounds={rounds} totalScore={totalScore} />
          {gameState?.isLoading ? (
            <div className="flex items-center justify-center gap-2 px-6 py-3 font-bold bg-yellow text-text-light rounded-2xl border-b-4 border-r-4 border-orange">
              <div className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]" />
              <span>{t('loading')}</span>
            </div>
          ) : (
            <Button text={t('newGame')} onClick={handleStartGame} />
          )}
          <br />
          <br />
          <br />
          <SurveyInfo />
          <br />
          <br />
          <section className="px-8">
            <TextInfo
              hasTitle={true}
              title={t('additionalInformation')}
              isContentText={true}
              content={t('additionalInformationText')}
            />
            <br />
            {/*There's a tiny mistake of format in really small screens*/}
            <Searchbar
              text={t('whatHidden')}
              linkType="external"
              link="https://medium.com/@up202208939/the-ghost-in-the-search-bar-what-autocomplete-says-about-us-f18a1465c029"
              type={'page'}
            />
            <br />
            <br />
            <br />
            <TextInfo hasTitle={false} isContentText={true} content={t('additionalInformationText2')} />
            <br />
            <Searchbar
              text={t('howGITSB')}
              linkType="internal"
              link="/article/howWeBuiltGITSB"
              type={'page'}
            />
          </section>
          <br />
          <VideoInfo />
        </main>
      </GhostWrapper>
      <GameEndGhosts />
      <Footer />
    </PageWrapper>
  );
}

export default GameEnd;
